import { gql } from "@apollo/client";

export const CREATE_BANK_STATEMENT = gql`
  mutation createBankStatement($input: createBankStatementInput) {
    createBankStatement(input: $input) {
      Id
    }
  }
`;






